import { AppAction } from 'actions/types/ActionTypes'
import { generateLuxPlusSubscriptionItems } from 'lib/checkout/luxPlusSubscription/cart'
import { fireEcommerceGTMEvent } from 'api/googleTagManager'
import { addToCartGTM } from 'analytics/eventDefinitions'
import { addToCheckoutCart } from 'actions/CheckoutActions'
import { navigateToCheckout } from 'checkout/actions/navigateActions'
import { getCanRedeemLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import { getRenewalOffer } from 'selectors/luxPlusSelectors'

interface PurchaseLuxPlus {
  hasJoinFee: boolean
  replaceCurrentWith?: string
}

function purchaseLuxPlus({ hasJoinFee, replaceCurrentWith }: PurchaseLuxPlus): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const currency = state.geo.currentCurrency
    const subscriptionProduct = state.luxPlus.products.subscription
    const isLuxPlusMember = getCanRedeemLuxPlusBenefits(state)

    if (isLuxPlusMember) {
      return
    }

    let offer = subscriptionProduct?.offers?.find(o => hasJoinFee ? !o.joinFeeWaived : o.joinFeeWaived)
    let isRenewal = false

    if (!hasJoinFee) {
      const renewal = getRenewalOffer(state)
      if (renewal.offer) {
        offer = renewal.offer
        isRenewal = renewal.isRenewal
      }
    }

    if (!offer) return

    const cartItems = generateLuxPlusSubscriptionItems(offer, isRenewal)
    const totalAmount = offer.price + (isRenewal ? 0 : offer.joinFee)
    fireEcommerceGTMEvent(addToCartGTM(offer, currency, totalAmount, undefined, 'subscription'))

    dispatch(addToCheckoutCart(cartItems))
    dispatch(navigateToCheckout({ replaceCurrentWith }))
  }
}

export default purchaseLuxPlus
